// extracted by mini-css-extract-plugin
export default {"band":"style_band__3z5Z+","logoBox":"style_logoBox__Xr1ci","logo":"style_logo__rD9n1","text":"style_text__bcrCm","name":"style_name__JOgtE","sub":"style_sub__ilneG"};